import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useMdUpScreen = () => {
	const theme = useTheme();
	// md, medium: 900px
	// Más de 900px, una manera de detectar que el dispositivo está horizontal
	const mdUpScreen = useMediaQuery(theme.breakpoints.up('md'));
	return mdUpScreen;
};

export default useMdUpScreen;
